<template>
  <div class='development-page' ref='content'>
    <ul class='pages'>
      <li @click='handleSubClick("API")'>
        <img src='../../assets/development/01.png'/>
        <div>API 参考</div>
      </li>
      <li @click='$router.push("/development/detail?page=SDK")'>
        <img src='../../assets/development/02.png'/>
        <div>SDK 下载</div>
      </li>
      <li @click='$router.push("/development/detail?page=DEMO")'>
        <img src='../../assets/development/11.png'/>
        <div>DEMO 体验</div>
      </li>
      <!-- <li @click='$router.push("/development/detail?page=FAQ")'>
        <img src='../../assets/development/03.png'/>
        <div>FAQ</div>
      </li> -->
    </ul>
    <div class='paas-products'>
      <h2>PaaS 产品</h2>
      <ul>
        <li v-for='p in paasProducts' :key='p.name' @click='handleSubClick("DOC", p.name)'>
          <img :src='require(`../../assets/development/${p.img}.png`)'/>
          <div>
            <h3>{{p.name}}</h3>
            <p>{{p.desc}}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import axios from 'axios';
import { paasProducts, saasProducts } from './products-config.js';

export default {
  name: 'Development',
  data() {
    return {
      paasProducts,
      saasProducts,
    }
  },
  mounted() {
    this.setHeight();
    window.addEventListener('resize', this.setHeight);
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setHeight);
  },
  methods: {
    // getDownUrl() {
    //    axios.get(`/templates/green/src/md/d-scc/down.json`).then(({data}) => {
    //      this.$set(this.content[this.content.length-1], 'list', data.data)
    //    })
    // },
    setHeight() {
      this.$refs.content.style.minHeight = window.innerHeight - 93 - 66 + 'px';
    },
    handleSubClick(page, product) {
      this.$router.push({
        name: 'developmentDetail',
        query: { product, page },
      })
    }
  },
}
</script>

<style lang="less">
.development-page {
  width: 1100px;
  margin: 0 auto;
  padding: 40px 0 30px;
  .pages {
    display: flex;
    justify-content: center;
    li {
      width: 257px;
      height: 90px;
      background: #fcfdff;
      border-radius: 10px;
      box-shadow: 0px 0px 12px 0px rgba(210,221,231,0.50);
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px 20px;
      border: 2px solid transparent;
      &:hover {
        border-color: #b1c4ff;
      }
      img {
        width: 50px;
        height: 50px;
        margin-right: 20px;
      }
      div {
        font-size: 21px;
        font-weight: 600;
        color: #666666;
        line-height: 29px;
        letter-spacing: -1px;
      }
      +li {
        margin-left: 66px;
      }
    }
  }
  .paas-products, .saas-products {
    margin-top: 60px;
    >h2 {
      font-size: 32px;
      font-weight: 600;
      text-align: center;
      color: #333333;
      line-height: 45px;
      letter-spacing: -1px;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      // justify-content: center;
      li {
        margin-top: 40px;
        display: flex;
        // align-items: flex-start;
        cursor: pointer;
       
        &:nth-of-type(even) {
          // margin-left: 75px;
        }
        &:hover >div h3 {
          color: #3B72F2
        }
        &:active >div h3 {
          text-decoration: underline;
        }
        >img {
          width: 40px;
          height: 40px;
          margin-right: 30px;
        }
        >div {
          width: 440px;
          h3 {
            font-size: 18px;
            font-weight: 600;
            color: #333333;
            line-height: 29px;
            letter-spacing: -1px;
          }
          p {
            margin: 10px 0 0;
            font-size: 16px;
            font-weight: 400;
            color: #666666;
            line-height: 25px;
          }
        }
        &:last-child {
        }
      }
    }
  }
  .saas-products ul li {
    margin-top: 20px;
    align-items: center;
    img {
      width: 200px;
      height: 200px;
    }
    >div {
      width: 300px;
      p {
        margin-top: 20px;
      }
    }
  }
}
</style>